module.exports = __webpack_public_path__ + "static/save_money_on_shipping-39051cc85ec0eca3f3fd517e410bceac.png";